module.exports = __webpack_public_path__ + "static/media/featureFilm.a73ca518.svg";